import { useCallback, useLayoutEffect, useRef } from "react"
import { get, size, isUndefined, isNaN } from "lodash"
import { TextField } from "@mui/material"
import PropTypes from "prop-types"
import classNames from "classnames"

export default function PreSelectedInput({ value, onChange, onFocus, onKeyDown, onBlur, variant = "outlined", isInput = true, disabled }) {
  const inputRef = useRef(null)

  // Select everything but units
  const setSelectionRange = useCallback(() => {
    const input = inputRef?.current?.getElementsByTagName("input")[0]

    if (!input) {
      return
    }
    const value = get(input, "value", "")
    let start, end
    for (let i = 0; i < size(value); i++) {
      const c = value[i]
      if (c.match(/[0-9]/) || c === "-") {
        if (isUndefined(start)) {
          start = i
        }
        end = i
      }
    }
    // It's possible for current to be null depending on the render
    input.setSelectionRange(start, end + 1)
  }, [])

  useLayoutEffect(() => {
    if (!isUndefined(inputRef?.current)) {
      // This is a hack to ensure the input text selection always works
      setTimeout(() => {
        setSelectionRange()
      }, 1)
    }
  }, [inputRef, setSelectionRange])

  const safeValue = isNaN(value) ? "" : value
  return <TextField
    disabled={disabled}
    size="small"
    ref={inputRef}
    value={safeValue}
    autoFocus={isInput} // We don't want to focus on fake inputs(when we want the behaviour of an input but the look of a non editable field)
    onChange={onChange}
    onFocus={onFocus}
    onKeyDown={onKeyDown}
    onBlur={onBlur}
    variant={variant}
    className={classNames({ "fake-input": !isInput })}
  />
}

PreSelectedInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  variant: PropTypes.string,
  isInput: PropTypes.bool,
  disabled: PropTypes.bool,
}
